// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qmONi","largestCol":"styles_largestCol__2nxQh","smallestCol":"styles_smallestCol__AMAJK"};